/* eslint-disable max-lines-per-function */
import React, { useEffect } from 'react'
import { format, clean } from 'rut.js'
import notification from 'antd/es/notification'
import { useParams } from 'react-router-dom'

import { useBack, useStateWithMerge } from 'hooks'
import { useAlert } from 'context'
import { Container, Typography, Icon } from 'components'
import API from 'config/apiAgenda'
import ReservationRequestByPatient from './ReservationRequestByPatient'

const initialState = {
  patientRut: null,
  isLoading: false,
  success: false,
  reservation: {},
  line: null,
}

// eslint-disable-next-line complexity
function ReservationCustomValidation({ history, match, location }) {
  const [state, setState] = useStateWithMerge(initialState)
  const { setAlert } = useAlert()
  const goBack = useBack()
  const { lineId } = useParams()

  const { isLoading, line } = state

  useEffect(() => {
    async function getLine() {
      try {
        const line = location.state
          ? location.state.line
          : await API.getLine(match.params.lineId)
        if (line.publicConfig) {
          setAlert(line.publicConfig.alert)
        }
        const formType = line.validatePatient
          ? `withValidatePatient`
          : `withoutValidatePatient`
        setState({
          line,
          formSchema: line.publicForms[formType],
        })
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e)
      }
    }
    getLine()
  }, [])

  async function patientRutQuery(patientRut) {
    setState({ isLoading: true })

    try {
      const [rut] = format(patientRut).split(`-`)
      const rutAsInt = parseInt(clean(rut), 10)
      const response = await API.validateRutForReservation(lineId, rutAsInt)

      history.push({
        pathname: `/fila/${response.lineId}/reserva`,
        state: { patientRut, line, customValidationFlow: true },
      })
    } catch (error) {
      // Ocurrio un error al consultar el rut
      notification.warn({
        message: error?.message ?? `Ha ocurrido un error, reintente.`,
      })
      goBack()
    }
  }

  return line == null ? (
    <Container width="100%" justifyContent="center" alignItems="center">
      <Icon icon="spinner" spin color="primary.2" fontSize="10" />
    </Container>
  ) : (
    <Container
      width="100%"
      flexDirection="column"
      alignItems="center"
      paddingX={4}
    >
      <Container
        width="100%"
        paddingBottom="4"
        flexDirection="column"
        alignItems="flex-start"
      >
        <Typography
          width="100%"
          color="primary.0"
          fontSize={{ _: 5, lg: 8 }}
          fontWeight="bold"
        >
          Confirmación de datos personales
        </Typography>
      </Container>

      <ReservationRequestByPatient
        patientRutQuery={patientRutQuery}
        isLoading={isLoading}
      />
    </Container>
  )
}

export default ReservationCustomValidation
